module.exports = __webpack_public_path__ + "static/desktop/img/calendar-4.e7f894bf.png";